import "./App.scss"

import { Route, Routes } from "react-router-dom"

import InitialData from "./appData/initialData"
import { AppStateProvider } from "./context/appStateContext"
import { BlackFridayProvider } from "./context/blackFridayContext"
import ConditionalFreeTrialPaywall from "./pages/ConditionalFreeTrialPaywall/ConditionalFreeTrialPaywall"
import ConditionalUltimatePaywall from "./pages/ConditionalUltimatePaywall/ConditionalUltimatePaywall"
import DefaultPaywall from "./pages/DefaultPaywall/DefaultPaywall"
import ExpirationPaywall from "./pages/ExpirationPaywall/ExpirationPaywall"
import LimitedTimePaywall from "./pages/LimitedTimePaywall/LimitedTimePaywall"
import PageList from "./pages/PageList"
import PromoBanner from "./pages/PromoPaywall/PromoBanner/PromoBanner"
import PromoPaywall from "./pages/PromoPaywall/PromoPaywall"
import createStyleConfig from "./styleConfig"
import SafeAreaInsetPage from "./components/SafeAreaInsetPage/SafeAreaInsetPage"
import SpecialOfferPaywall from "./pages/SpecialOfferPaywall/SpecialOfferPaywall"
import { ExpirationProvider } from "./context/expirationContext"
import ExpirationModernPaywall from "./pages/ExpirationModernPaywall/ExpirationModernPaywall"
import AnimatedPaywall from "./pages/AnimatedPaywall/AnimatedPaywall"
import MultiStepPaywall from "./pages/MultiStepPaywall/MultiStepPaywall"
import FreeTrialPaywall from "./pages/FreeTrialPaywall/FreeTrialPaywall"
import TAPaywall from "./pages/TAPaywall/TAPaywall"
import SummerBanner from "./pages/SummerPaywall/SummerBanner/SummerBanner"
import SummerPaywall from "./pages/SummerPaywall/SummerPaywall"
import BubbleExpirationPaywall from "./pages/BubbleExpirationPaywall/BubbleExpirationPaywall"
import EmailPromoPaywall from "./pages/EmailPromoPaywall/EmailPromoPaywall"
import HalloweenPaywall from "./pages/HalloweenPaywall/HalloweenPaywall"
import HalloweenBanner from "./pages/HalloweenPaywall/HalloweenBanner"
import AutumnPaywall from "./pages/AutumnPaywall/AutumnPaywall"
import AutumnBanner from "./pages/AutumnPaywall/AutumnBanner/AutumnBanner"
import WinterPaywall from "./pages/WinterPaywall/WinterPaywall"
import WinterBanner from "./pages/WinterPaywall/WinterBanner/WinterBanner"
import SpringPaywall from "./pages/SpringPaywall/SpringPaywall"
import SpringBanner from "./pages/SpringPaywall/SpringBanner/SpringBanner"
import OnboardingUltimateAlternatePaywall from "./pages/OnboardingUltimateAlternatePaywall/OnboardingUltimateAlternatePaywall"
import BlackFriday2025Paywall from "./pages/BlackFriday2025Paywall/BlackFriday2025Paywall"
import BlackFriday2025Banner from "./pages/BlackFriday2025Paywall/BlackFriday2025Banner/BlackFriday2025Banner"
import BlackFridayNoFeaturesPaywall from "./pages/BlackFridayNoFeaturesPaywall/BlackFridayNoFeaturesPaywall"
import CyberMonday2025Paywall from "./pages/CyberMonday2025Paywall/CyberMonday2025Paywall"
import CyberMonday2025Banner from "./pages/CyberMonday2025Paywall/CyberMonday2025Banner/CyberMonday2025Banner"
import TabsPaywall from "./pages/TabsPaywall/TabsPaywall"
import ThreeStepPaywall from "./pages/ThreeStepPaywall/ThreeStepPaywall"
import BackupPaywall from "./pages/BackupPaywall/BackupPaywall"
import OneStepExpirationPaywall from "./pages/OneStepExpirationPaywall/OneStepExpirationPaywall"
import SocialProofPaywall from "./pages/SocialProofPaywall/SocialProofPaywall"
import YearlyOnlyAppStorePaywall from "./pages/YearlyOnlyAppStorePaywall/YearlyOnlyAppStorePaywall"
import ImportPhotosScreen from "./pages/ImportPhotosScreen/ImportPhotosScreen"
import LossAversionPaywall from "./pages/LossAversionPaywall/LossAversionPaywall"
import AuroraVaultPaywall from "./pages/AuroraVaultPaywall/AuroraVaultPaywall"
import BreakInPaywall from "./pages/BreakInPaywall/BreakInPaywall"
import DeepFreezePaywall from "./pages/DeepFreezePaywall/DeepFreezePaywall"
import KeyholderPaywall from "./pages/KeyholderPaywall/KeyholderPaywall"
import VaultWrappedPaywall from "./pages/VaultWrappedPaywall/VaultWrappedPaywall"
import AbyssPaywall from "./pages/AbyssPaywall/AbyssPaywall"
import VaultDoorPaywall from "./pages/VaultDoorPaywall/VaultDoorPaywall"
import DecoyPaywall from "./pages/DecoyPaywall/DecoyPaywall"
import RecallPaywall from "./pages/RecallPaywall/RecallPaywall"
import FeatherweightPaywall from "./pages/FeatherweightPaywall/FeatherweightPaywall"
import ReclaimedPaywall from "./pages/ReclaimedPaywall/ReclaimedPaywall"
import KindredPaywall from "./pages/KindredPaywall/KindredPaywall"
import ReceiptPaywall from "./pages/ReceiptPaywall/ReceiptPaywall"
import TidyPaywall from "./pages/TidyPaywall/TidyPaywall"
import AtlasPaywall from "./pages/AtlasPaywall/AtlasPaywall"
import OriginalPaywall from "./pages/OriginalPaywall/OriginalPaywall"
import BoundPaywall from "./pages/BoundPaywall/BoundPaywall"

let preReactInitialData: InitialData | undefined = undefined

function initialDataLoad(data: InitialData) {
  preReactInitialData = data
}

;(window as any).initialDataLoad = initialDataLoad

const App = () => {
  return (
    <AppStateProvider
      sendAllProductData={false}
      isPromo={false}
      styleConfigCreator={createStyleConfig}
    >
      <BlackFridayProvider>
        <ExpirationProvider>
          <AppContent />
        </ExpirationProvider>
      </BlackFridayProvider>
    </AppStateProvider>
  )
}

function AppContent() {
  return (
    <SafeAreaInsetPage>
      <Routes>
        <Route path="/" element={<PageList />}></Route>
        <Route
          path="/freetrialpaywall"
          element={
            <ConditionalFreeTrialPaywall freeTrialPaywall={FreeTrialPaywall} />
          }
        />
        <Route
          path="/ultimatepaywall"
          element={<ConditionalUltimatePaywall />}
        />
        <Route path="/limitedtimepaywall" element={<LimitedTimePaywall />} />
        <Route path="/promo" element={<PromoPaywall />} />
        <Route path="/promo/banner" element={<PromoBanner />} />
        <Route path="/blackFriday" element={<PromoPaywall />} />
        <Route path="/blackFriday/banner" element={<PromoBanner />} />
        <Route path="/expiration" element={<ExpirationPaywall />} />
        <Route path="/expirationModern" element={<ExpirationModernPaywall />} />
        <Route path="/default" element={<DefaultPaywall />} />
        <Route path="/specialOffer" element={<SpecialOfferPaywall />} />
        <Route path="/animatedPaywall" element={<AnimatedPaywall />} />
        <Route path="/multiStep" element={<MultiStepPaywall />} />
        <Route path="/taPaywall" element={<TAPaywall />} />
        <Route path="/promoSummer" element={<SummerPaywall />} />
        <Route path="/promoSummer/banner" element={<SummerBanner />} />
        <Route path="/promoHalloween" element={<HalloweenPaywall />} />
        <Route path="/promoHalloween/banner" element={<HalloweenBanner />} />
        <Route path="/promoAutumn" element={<AutumnPaywall />} />
        <Route path="/promoAutumn/banner" element={<AutumnBanner />} />
        <Route path="/promoWinter" element={<WinterPaywall />} />
        <Route path="/promoWinter/banner" element={<WinterBanner />} />
        <Route path="/promoSpring" element={<SpringPaywall />} />
        <Route path="/promoSpring/banner" element={<SpringBanner />} />
        <Route
          path="/promoBlackFriday2025"
          element={<BlackFriday2025Paywall />}
        />
        <Route
          path="/promoBlackFriday2025/banner"
          element={<BlackFriday2025Banner />}
        />
        <Route
          path="/promoBlackFridayNoFeatures"
          element={<BlackFridayNoFeaturesPaywall />}
        />
        <Route
          path="/promoCyberMonday2025"
          element={<CyberMonday2025Paywall />}
        />
        <Route
          path="/promoCyberMonday2025/banner"
          element={<CyberMonday2025Banner />}
        />
        <Route path="/bubbleExpiration" element={<BubbleExpirationPaywall />} />
        <Route path="/expirationGridPaywall" element={<ThreeStepPaywall />} />
        <Route path="/tabsPaywall" element={<TabsPaywall />} />
        <Route path="/backupPaywall" element={<BackupPaywall />} />
        <Route path="/emailPromo" element={<EmailPromoPaywall />} />
        <Route
          path="/oneStepExpiration"
          element={<OneStepExpirationPaywall />}
        />
        <Route path="/socialProof" element={<SocialProofPaywall />} />
        <Route
          path="/yearlyOnlyAppstore"
          element={<YearlyOnlyAppStorePaywall />}
        />
        <Route path="/importPhotos" element={<ImportPhotosScreen />} />
        <Route path="/lossAversion" element={<LossAversionPaywall />} />
        <Route path="/auroraVault" element={<AuroraVaultPaywall />} />
        <Route path="/caught" element={<BreakInPaywall />} />
        <Route path="/deepFreeze" element={<DeepFreezePaywall />} />
        <Route path="/keyholder" element={<KeyholderPaywall />} />
        <Route path="/vaultWrapped" element={<VaultWrappedPaywall />} />
        <Route path="/abyss" element={<AbyssPaywall />} />
        <Route path="/vaultDoor" element={<VaultDoorPaywall />} />
        <Route path="/decoy" element={<DecoyPaywall />} />
        <Route path="/recall" element={<RecallPaywall />} />
        <Route path="/featherweight" element={<FeatherweightPaywall />} />
        <Route path="/kindred" element={<KindredPaywall />} />
        <Route path="/receipt" element={<ReceiptPaywall />} />
        <Route path="/tidy" element={<TidyPaywall />} />
        <Route path="/reclaimed" element={<ReclaimedPaywall />} />
        <Route path="/atlas" element={<AtlasPaywall />} />
        <Route path="/original" element={<OriginalPaywall />} />
        <Route path="/bound" element={<BoundPaywall />} />
        <Route
          path="/onboardingUltimateAlternate"
          element={
            <ConditionalFreeTrialPaywall
              freeTrialPaywall={OnboardingUltimateAlternatePaywall}
            />
          }
        />
      </Routes>
    </SafeAreaInsetPage>
  )
}

export default App
export { preReactInitialData }
